const splitContentSliders = document.querySelectorAll<HTMLElement>(
	'.split-content-number-highlight .slider',
)
splitContentSliders.forEach(slider => {
	const container = slider.querySelector<HTMLElement>('.slide-container')
	const prevBtn = slider.querySelector<HTMLElement>('.prev')
	const nextBtn = slider.querySelector<HTMLElement>('.next')
	const images = Array.from(slider.querySelectorAll<HTMLElement>('.img-wrapper'))
	const numSlides = images.length
	if (!container || !prevBtn || !nextBtn || numSlides === 0) return

	const scrollTo = (index: number) => {
		container.scroll({
			left: images[index].offsetLeft,
			behavior: 'smooth',
		})
	}

	const carouselA11y = (window as any).carouselA11y
	if (carouselA11y) {
		carouselA11y.initCustomCarousel({
			root: slider,
			slides: images,
			prevBtn,
			nextBtn,
			onChange: (index: number) => scrollTo(index),
		})
		return
	}

	let currentPos = 0
	prevBtn.addEventListener('click', () => {
		currentPos = (currentPos - 1 + numSlides) % numSlides
		scrollTo(currentPos)
	})
	nextBtn.addEventListener('click', () => {
		currentPos = (currentPos + 1) % numSlides
		scrollTo(currentPos)
	})
})
